export default __webpack_public_path__ + "static/media/breast2.42614c94.jpg";